exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-dropdown__fader{background:#000;height:100%;opacity:.25;position:fixed;top:0;width:100%;z-index:0}.ebx-dropdown__fader--fade-enter,.ebx-dropdown__fader--fade-leave-to{opacity:0}[dir=ltr] .ebx-dropdown__fader,[dir=rtl] .ebx-dropdown__fader{left:0}", ""]);
